<app-tool-loader [isLoading]="isLoading()" positionUnset="true">
  <form [formGroup]="form.formGroup">
    <p-tabs value="0">
      <p-tablist>
        <p-tab value="0">Operation Details
          @if (form.formGroup.controls.injectionPressure.invalid ||
                form.formGroup.controls.inletTemperature.invalid || form.formGroup.controls.gasFlowRate.invalid) {
            <i class="validation-error pi pi-exclamation-circle pl-1" pTooltip="Operation not saved, some required inputs not specified."></i>
          }
        </p-tab>
      </p-tablist>

      <p-tabpanels class="pl-4 pr-2">
        <p-tabpanel value="0">
          <div class="flex flex-col space-y-2 pb-4">
            <div class="flex flex-col">
              <label for="fluid">Injection Gas</label>
              <p-select [options]="fluids" [formControlName]="form.formControlNames.fluid" optionLabel="state.name"
              dataKey="id" appendTo="body" tooltipPosition="top">
              <ng-template pTemplate="selectedItem">
                {{ form.formGroup.value.fluid?.state?.name }}
              </ng-template>
              <ng-template let-fluid pTemplate="item">
                {{ fluid.state.name }}
              </ng-template>
            </p-select>
            </div>

            <div class="flex flex-col">
              <label for="perforation">Gas Lift Valve</label>
              <p-select [options]="gasLiftValves" [formControlName]="form.formControlNames.gasLiftValve"
                optionLabel="name" appendTo="body">
              </p-select>
            </div>

            <div class="flex flex-col">
              <label for="wellheadPressure">Injection Pressure</label>
              <p-inputgroup>
                <p-inputnumber id="wellheadPressure" [formControlName]="form.formControlNames.injectionPressure" />
                <p-inputgroup-addon>{{ pressureUnit }}</p-inputgroup-addon>
              </p-inputgroup>
              @if (form.formGroup.controls.injectionPressure.value && form.formGroup.controls.injectionPressure.invalid) {
                <p class="validation-error">
                  Allowed range: {{ pressureValidation.min }} - {{ pressureValidation.max }} {{ pressureUnit }}
                </p>
              }
            </div>
            <div class="flex flex-col">
              <label for="inletTemperature">Inlet Temperature</label>
              <p-inputgroup>
                <p-inputnumber [formControlName]="form.formControlNames.inletTemperature" />
                <p-inputgroup-addon>{{ tempUnit }}</p-inputgroup-addon>
              </p-inputgroup>
              @if (form.formGroup.controls.inletTemperature.value && form.formGroup.controls.inletTemperature.invalid) {
                <p class="validation-error">
                  Allowed range: {{ temperatureValidation.min }} - {{ temperatureValidation.max }} {{ tempUnit }}
                </p>
              }
            </div>
            <div class="flex flex-col">
              <label for="gasRate">Gas Rate</label>
              <p-inputgroup>
                <p-inputnumber [formControlName]="form.formControlNames.gasFlowRate" [minFractionDigits]="1" />
                <p-inputgroup-addon>{{ gasFlowUnit }}</p-inputgroup-addon>
              </p-inputgroup>
            </div>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </form>
</app-tool-loader>